import React, { useEffect, useState } from 'react';

import './StickyMobileCTA.scss';
import * as Util from '../Util';

const DISMISS_KEY = 'wabi:stickyCtaDismissed';

const StickyMobileCTA = ({ isAuthed, history, observeSelector = '.HeroSection' }) => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    try {
      if (sessionStorage.getItem(DISMISS_KEY) === '1') {
        setDismissed(true);
        return;
      }
    } catch (err) {
      // sessionStorage may be unavailable (private mode, etc.) — fall through
    }

    const target = document.querySelector(observeSelector);
    if (!target || typeof IntersectionObserver === 'undefined') {
      // Fallback: reveal immediately so the CTA is still reachable.
      setVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Show the sticky CTA only once the hero has scrolled out of view.
        setVisible(!entry.isIntersecting);
      },
      { threshold: 0 }
    );
    observer.observe(target);
    return () => observer.disconnect();
  }, [observeSelector]);

  if (dismissed) return null;

  const label = isAuthed ? 'Go to Dashboard' : 'Get started';
  const path = isAuthed ? '/dashboard' : '/start/step1';

  const handleClick = () => {
    if (Util.isProduction()) {
      if (window.amplitude) {
        window.amplitude
          .getInstance()
          .logEvent('Sticky CTA Clicked', { authed: !!isAuthed });
      }
      if (window.mixpanel) {
        window.mixpanel.track('Sticky CTA Clicked', { authed: !!isAuthed });
      }
    }
    history.push(path);
  };

  const handleDismiss = () => {
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch (err) {
      // ignore
    }
    if (Util.isProduction()) {
      if (window.amplitude) {
        window.amplitude.getInstance().logEvent('Sticky CTA Dismissed');
      }
      if (window.mixpanel) {
        window.mixpanel.track('Sticky CTA Dismissed');
      }
    }
    setDismissed(true);
  };

  return (
    <div
      className={`StickyMobileCTA${visible ? ' StickyMobileCTA--visible' : ''}`}
      role="region"
      aria-label="Get started with Wabi"
    >
      <div className="StickyMobileCTA__inner">
        <div className="StickyMobileCTA__copy">
          <span className="StickyMobileCTA__title">
            {isAuthed ? 'Pick up where you left off' : 'Empty your mailbox'}
          </span>
          <span className="StickyMobileCTA__sub">
            {isAuthed ? 'Open your dashboard' : '3 free opt-outs to start'}
          </span>
        </div>
        <button
          type="button"
          className="StickyMobileCTA__cta"
          onClick={handleClick}
        >
          {label}
        </button>
        <button
          type="button"
          className="StickyMobileCTA__dismiss"
          onClick={handleDismiss}
          aria-label="Dismiss"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            aria-hidden="true"
            focusable="false"
          >
            <path
              d="M2 2l10 10M12 2L2 12"
              stroke="currentColor"
              strokeWidth="1.75"
              strokeLinecap="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default StickyMobileCTA;
